import { StyledDateField } from "./date-field.style";
import { IMDSDateFieldProps } from "./date-field.types";

export function MDSDateField(props: IMDSDateFieldProps) {
  return <StyledDateField {...props} />;
}
